let currentTime = new Date().toISOString();
export const CARBON_DILIGENCE_APIS = [
	{
		name: "GetReportList",
		type: "post",
		api: "api/Report/GetReportList",
	},
	{
		name: "verifyEmail",
		type: "get",
		api: "api/Accounts/IsEmailConfirmed",
	},
	{
		name: "ExportReportsList",
		type: "export",
		api: "/api/Report/GetReportListExcel?reportYear",
	},
	{
		name: "GetReportDetailsByReportId",
		type: "get",
		api: "api/Report/GetReportDetails?reportMstId",
	},
	{
		name: "GetVoyagesByReportId",
		type: "get",
		api:
			"api/Voyages/GetVoyages?cacheburst=" +
			currentTime +
			" &reportMstId",
	},
	{
		name: "GetReportPortCodes",
		type: "post",
		api: "api/PortCode/GetReportPortCodes",
	},
	{
		name: "GetGlobalErrors",
		type: "get",
		api: "api/Report/GetGlobalErrors?reportMstId",
	},
	{
		name: "GetVoyagesExcel",
		type: "export",
		api: "api/Voyages/GetVoyagesExcel?reportMstId",
	},
	{
		name: "AddVoyage",
		type: "post",
		api: "/api/Voyages/AddMepcVoyage",
	},
	{
		name: "EditVoyage",
		type: "post",
		api: "/api/Voyages/EditVoyage",
	},
	{
		name: "DeleteVoyage",
		type: "post",
		api: "api/Voyages/DeleteVoyage",
	},
	{
		name: "GetBDNVoyagesByReportId",
		type: "get",
		api: "api/Voyages/GetBDNVoyagesByReportId?reportMstId",
	},

	{
		name: "GetVoyageBdns",
		type: "get",
		api: "api/Voyages/GetVoyageBdns?reportMstId",
	},
	{
		name: "AddVoyageBdn",
		type: "post",
		api: "/api/VoyageBdn/AddVoyageBdn",
	},
	{
		name: "EditVoyageBdn",
		type: "post",
		api: "/api/VoyageBdn/EditVoyageBdn",
	},
	{
		name: "GetVerifyEngineers",
		type: "get",
		api: "api/Verification/GetVerifyEngineers?searchTerm",
	},
	{
		name: "DownloadReportDocuments",
		type: "export",
		api: "api/Documents/DownloadReportDocuments?reportMstId",
	},
	{
		name: "GetDocumentsListByReportMstId",
		type: "get",
		api: "api/Documents/GetDocuments?reportMstId",
	},
	{
		name: "DeleteVoyageBdn",
		type: "post",
		api: "api/VoyageBdn/DeleteVoyageBdn",
	},
	{
		name: "GetVoyageBdnsExcel",
		type: "export",
		api: "api/VoyageBdn/GetVoyageBdnsExcel?reportMstId",
	},
	{
		name: "GetAssociatedDocuments",
		type: "get",
		api: "/api/Documents/GetAssociatedVerificationDocuments?reportMstId",
	},
	{
		name: "SetAvailableToClient",
		type: "post",
		api: "api/Documents/SetAvailableToClient",
	},
	{
		name: "GetChildMrvVoyages",
		type: "post",
		api: "api/Report/GetChildMrvVoyages?systemChildReportMstId",
	},
	{
		name: "GetEuMrvVoyagesExcel",
		type: "export",
		api: "api/Report/GetEuMrvVoyagesExcel?reportMstId",
	},
	{
		name: "GetUkMrvVoyagesExcel",
		type: "export",
		api: "api/Report/GetUkMrvVoyagesExcel?reportMstId",
	},
	{
		name: "GetEuMrvPortStaysExcel",
		type: "export",
		api: "api/Report/GetEuMrvPortStaysExcel?reportMstId",
	},
	{
		name: "GetUkMrvPortStaysExcel",
		type: "export",
		api: "api/Report/GetUkMrvPortStaysExcel?reportMstId",
	},
	{
		name: "GetReviewEngineers",
		type: "get",
		api: "api/Report/GetReviewEngineers?searchTerm",
	},
	{
		name: "AssignReport",
		type: "post",
		api: "api/Report/AssignReport",
	},
	{
		name: "ClaimReport",
		type: "post",
		api: "api/Report/ClaimReport",
	},
	{
		name: "UnclaimReport",
		type: "post",
		api: "api/Report/UnclaimReport",
	},
	{
		name: "submitToABS",
		type: "get",
		api: "api/Report/SubmitToAbs?reportMstId",
	},
	{
		name: "GetIsAnyMisStatementErrors",
		type: "get",
		api: "api/Report/GetReportFlags?reportMstId",
	},
	{
		name: "GenerateEtsDocument",
		type: "blob",
		api: "api/Report/GenerateEtsDocument",
	},
	{
		name: "GetReportFlags",
		type: "get",
		api: "api/Report/GetReportFlags?reportMstId",
	},
	{
		name: "GetAllowedVesselConsumer",
		type: "get",
		api: "api/Report/GetAllowedVesselConsumer?vesselMstId",
	},
	{
		name: "GetBdnForm",
		type: "get",
		api: `api/VoyageBdn/GetBdnForm?vesselMstId`,
	},
	{
		name: "GetVoyageForm",
		type: "get",
		api: `api/Voyages/GetVoyageForm?vesselMstId`,
	},
	{
		name: "GetNotifications",
		type: "get",
		api: `api/Notifications/GetNotifications`,
	},
	{
		name: "deleteDocument",
		type: "delete",
		api: `api/Documents/DeleteDocuments?documentMstId`,
	},
	{
		name: "GetPlanVerificationList",
		type: "post",
		api: `api/PlanVerification/GetPlanVerificationList`,
	},
	{
		name: "DownloadVerificationPlan",
		type: "get",
		api: `api/PlanVerification/DownloadVerificationPlan?planId`,
	},
	{
		name: "AddVerificationPlan",
		type: "post",
		api: `api/PlanVerification/AddVerificationPlan`,
	},
	{
		name: "GetPlanVerificationDetailsByPlanId",
		type: "get",
		api: "api/PlanVerification/GetPlanVerificationDetails?planId",
	},
	{
		name: "GetUkEtsReportSummary",
		type: "get",
		api: "api/UkEts/GetUkEtsReportSummary?childReportId",
	},
	{
		name: "GetImoVesselType",
		type: "get",
		api: `api/MasterData/GetImoVesselType`,
	},
	{
		name: "GetMrvVesselType",
		type: "get",
		api: "api/MasterData/GetMrvVesselType",
	},
	{
		name: "GetUKETSVerification",
		type: "get",
		api: "api/UKEtsAer/GetVerification?ukEtsAerMstId",
	},
	{
		name: "GetUKETSVerificationDetailsByReportId",
		type: "get",
		api: "api/UkEtsCompanyReport/verification-details?ukEtsCompanyReportId"
	},
	{

		name:"GetUkVesselType",
		type:"get",
		api:"api/MasterData/GetUkVesselType"
	},
{
		name: "CVRSetAvailableToClient",
		type: "put",
		api: "api/CompanyVerification/avail-to-client",
	},
	{
		name: "GetCVRAssociatedDocuments",
		type: "get",
		api: "api/CompanyVerification/docs?companyVerificationReportId",
	},
	{
		name: "GetCVRReportDetailsByReportId",
		type: "get",
		api: "api/CompanyVerification/verification-details?companyVerificationReportId",
	},
];

export const WEBHOOK_STATUS_URL = "/api/webhook/status";
export const WEBHOOK_CANCEL_URL = "/api/webhook/cancel";
export const WEBHOOK_ENQUEUE_URL = "/api/webhook/enqueue";